import { render, staticRenderFns } from "./complaint-reject.vue?vue&type=template&id=457014a2&scoped=true&"
import script from "./complaint-reject.vue?vue&type=script&lang=js&"
export * from "./complaint-reject.vue?vue&type=script&lang=js&"
import style0 from "./complaint-reject.vue?vue&type=style&index=0&id=457014a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457014a2",
  null
  
)

export default component.exports